// extracted by mini-css-extract-plugin
module.exports = {"apiVersion":"APIVersionSwitcher_apiVersion__KzU1_","wrapper":"APIVersionSwitcher_wrapper__z0XdU","apiVersionText":"APIVersionSwitcher_apiVersionText__O1my6"};